'use strict';

document.addEventListener('DOMContentLoaded', function () {

    var _AGB_RECS_DEBUG = false;
    var console = (_AGB_RECS_DEBUG && typeof window !== 'undefined' && window.console)
        ? window.console
        : { log: function(){}, warn: function(){}, info: function(){}, error: function(){} };

    // Define the itemsToRemove at the top level
    var itemsToRemove = [
        "Plate Carrier Giveaway",
        "Become a gear tester",
        "Military/LE Discount",
        "Mil/LE Discount",
        "About Us",
        "Magnetix Battle Belt Giveaway"
    ];
      // Check if visitorID was generated in this session
    const visitorIdGeneratedThisSession = sessionStorage.getItem('visitorIdGeneratedThisSession') === 'true';

    // Check if recommendation fetch previously failed
    const recommendationFetchFailed = sessionStorage.getItem('recommendationFetchFailed') === 'true';

    // Function to generate a unique visitor ID (UUID)
    function generateUUID() {
      var d = new Date().getTime();
      var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
  
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0;
  
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else if (d2 > 0) {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
  
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

    // Function to set a cookie
    function setCookie(name, value, days) {
      if (!value || value === "1") {
          console.error("Invalid visitorID assigned:", value);
          return;
      }
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
        // keep localStorage in sync with cookie
    if (name === 'visitorID') {
        localStorage.setItem('visitorID', value);
    }
}

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i].trim();
          if (c.indexOf(nameEQ) == 0) {
              var value = c.substring(nameEQ.length, c.length);
              if (value === "1") {
                  console.warn("Detected invalid visitorID '1', removing...");
                  deleteCookie(name);
                  return null;
              }
              return value;
          }
      }
      return null;
}

// Ensure localStorage mirrors the cookie when cookie exists
function syncVisitorIDFromCookie() {
  var c = getCookie('visitorID');
  if (c && localStorage.getItem('visitorID') !== c) {
    localStorage.setItem('visitorID', c);
  }
}

    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    // Get the email parameter from the URL
    function getEmailFromURL() {
      var urlParams = new URLSearchParams(window.location.search);
      var email = urlParams.get('email');  // Get the email from the URL
      if (email) {
          email = email.replace(/\s/g, '+');  // Replace any spaces with "+"
      }
      console.log("Email:", email);  // Log the email before returning it
    return email;  // Return the email
}

    // Function to request visitorID from the server
    function requestVisitorID(email, visitorID) {
        fetch('https://database-app-1.onrender.com/save-visitor', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: email, visitorID: visitorID })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                console.log("Visitor ID validated from server:", data.visitorID);
                setCookie('visitorID', data.visitorID, 300);
                localStorage.setItem('visitorID', data.visitorID);

            } else {
                console.log("Visitor ID not found in database, removing...");
                deleteCookie('visitorID');
            }
        })
        .catch(error => console.error("Error requesting visitor ID:", error));
    }

    // Main logic to check or set visitorID
var visitorID = getCookie('visitorID');  // Check if visitorID is already stored in a cookie
syncVisitorIDFromCookie();
var email = getEmailFromURL();  // Get the email parameter from the URL

if (!visitorID && email) {
        // Only generate visitor ID if the user has an email in the URL
        visitorID = generateUUID();
        setCookie('visitorID', visitorID, 300);
        localStorage.setItem('visitorID', visitorID);

        sessionStorage.setItem('visitorIdGeneratedThisSession', 'true');
        requestVisitorID(email, visitorID);
} else if (visitorID && email) {
        // If visitor ID exists, check with backend to see if it's valid
        requestVisitorID(email, visitorID);
}

    // ── Country resolution (end-to-end) ──────────────────────────────────────
    // localStorage['country'] is what the TTB country patch, best-seller, and
    // returning-user flows read. /get-recommendations runs on database-app-1
    // (geoip DISABLED) so it returns no country for a fresh visitor. /api/whoami
    // on database-app-2 (geoip ENABLED) resolves it from the cached GeoLite2-
    // Country DB — that's the reliable source. Run it on every load: no-op once
    // a real country is cached, fail-open, treats the legacy "null"/"undefined"
    // strings as empty so previously-poisoned visitors re-resolve.
    (function ensureCountryResolved() {
        try {
            var cur = localStorage.getItem('country');
            if (cur && cur !== 'null' && cur !== 'undefined') return;
            // Pass the (already-adopted) visitorID so a FAKE id (facade00-) resolves
            // to its panel-set country here too — otherwise whoami returns the
            // impersonating operator's real geoip country and races the
            // /get-recommendations fake-country write. Harmless for real ids
            // (region_persist=0 → no IP mirror write either way).
            var _vid = '';
            try { _vid = localStorage.getItem('visitorID') || ''; } catch (e) {}
            var _wurl = 'https://database-app-2-lcae.onrender.com/api/whoami?region_enabled=1&region_persist=0'
                + (_vid ? '&visitorID=' + encodeURIComponent(_vid) : '');
            fetch(_wurl)
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (w) {
                    if (w && w.country) {
                        localStorage.setItem('country', w.country);
                        try { console.log('[country] resolved from geoip:', w.country); } catch (e) {}
                    }
                })
                .catch(function () { /* fail-open: no country -> default patch */ });
        } catch (e) {}
    })();

     // Check if recommendations and country/tande data are already in localStorage
const THIRTY_DAYS_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
const recommendationFetchTime = localStorage.getItem('recommendationFetchTime');

function waitForResolvedVisitorId(timeoutMs) {
    return new Promise(function (resolve) {
        // Already resolved? Take it.
        try {
            if (window.SE_visitorIdentity && window.SE_visitorIdentity.visitor_id) {
                resolve(window.SE_visitorIdentity.visitor_id);
                return;
            }
        } catch (e) {}
        var done = false;
        function finish(id) {
            if (done) return;
            done = true;
            window.removeEventListener('SE_visitorIdentified', onEvent);
            resolve(id || null);
        }
        function onEvent(e) {
            var id = e && e.detail && e.detail.visitor_id;
            finish(id || null);
        }
        window.addEventListener('SE_visitorIdentified', onEvent);
        // Timeout = fall back to whatever's in localStorage.
        setTimeout(function () {
            finish(localStorage.getItem('visitorID'));
        }, timeoutMs);
    });
}

function fetchRecommendationsFor(canonicalVisitorId) {
    if (!canonicalVisitorId) {
        console.error("VisitorID not found after group resolution.");
        sessionStorage.setItem('recommendationFetchFailed', 'true');
        return;
    }
    var lastCachedFor = localStorage.getItem('recommendationFetchVisitorId');
    localStorage.setItem('visitorID', canonicalVisitorId);
    fetch('https://database-app-1.onrender.com/get-recommendations', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            visitorID: canonicalVisitorId
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            console.log("Recommended products and country/tande data fetched and stored in localStorage");
            // Store recommendations, country, and tande in localStorage
            localStorage.setItem('recommendedProducts', JSON.stringify(data.recommendedProducts));
            // /get-recommendations runs on database-app-1, where geoip is DISABLED,
            // so data.country is null for any visitor without a stored country.
            //   (a) NEVER store the literal "null" string (old bug: it made the
            //       re-fetch guard think a country was set and never retry).
            //   (b) Fall back to /api/whoami on database-app-2 (geoip ENABLED — it
            //       now returns `country` from the cached GeoLite2-Country DB) so
            //       localStorage['country'] is populated THIS load. The TTB country
            //       patch, best-seller, and returning-user flows all read it.
            // Only store a REAL country (never the literal "null"). The geoip
            // fallback when /get-recommendations has none is handled once, up
            // front, by ensureCountryResolved() — don't duplicate it here.
            if (data.country) {
                localStorage.setItem('country', data.country);
            }
            localStorage.setItem('tande', data.tande);
            localStorage.setItem('recommendationFetchTime', Date.now());
            localStorage.setItem('recommendationFetchVisitorId', canonicalVisitorId);
            executePageUpdates(data.recommendedProducts, data.tande, data.country); // Call function to execute updates
        } else {
            console.error("Error fetching recommendations:", data.message);
            sessionStorage.setItem('recommendationFetchFailed', 'true');
        }
    })
    .catch(error => console.error("Error fetching recommendations:", error));
}

var lastCachedFor = localStorage.getItem('recommendationFetchVisitorId');
var cachedRecs = localStorage.getItem('recommendedProducts');
var needFreshFetch = (
    (!visitorIdGeneratedThisSession &&
     !recommendationFetchFailed &&
     !cachedRecs) ||
    cachedRecs === '[]' ||
    !localStorage.getItem('country') ||
    localStorage.getItem('country') === 'null' ||
    localStorage.getItem('country') === 'undefined' ||
    !recommendationFetchTime ||
    (Date.now() - parseInt(recommendationFetchTime) > THIRTY_DAYS_MS)
);

// Late-identity watchdog. If the engine's _bootVisitorIdentity takes longer
// than waitForResolvedVisitorId's 2s timeout (Render cold-start, slow
// network), we'll have fetched recs for whatever was in localStorage at
// that moment. The engine eventually resolves the canonical id and sets
// window.SE_visitorIdentity / dispatches SE_visitorIdentified. This
// watchdog catches that late arrival, refetches for the canonical id,
// and re-applies. Without it, the page renders wrong recs until the next
// navigation triggers the cache-mismatch self-heal.
function _watchLateIdentity(initialFetchedId) {
    if (!initialFetchedId) return;
    var fired = false;
    function reactToLate(lateId) {
        if (fired) return;
        if (!lateId || lateId === initialFetchedId) return;
        fired = true;
        window.removeEventListener('SE_visitorIdentified', listener);
        fetchRecommendationsFor(lateId);
    }
    function listener(e) {
        reactToLate(e && e.detail && e.detail.visitor_id);
    }
    window.addEventListener('SE_visitorIdentified', listener);
    // Catch the case where the event fired BETWEEN our 2s timeout and now
    // (the window.SE_visitorIdentity cache is set inside the engine right
    // before dispatchEvent, so checking it on next tick is reliable).
    setTimeout(function () {
        var w = window.SE_visitorIdentity;
        if (w && w.visitor_id) reactToLate(w.visitor_id);
    }, 0);
    // Bound the listener lifetime so it doesn't leak past the engine's
    // cold-start window. 30s is generous; identify rarely takes more than
    // 10-15s even on a fully cold Render dyno.
    setTimeout(function () {
        window.removeEventListener('SE_visitorIdentified', listener);
    }, 30000);
}

if (needFreshFetch) {
    waitForResolvedVisitorId(2000).then(function (resolvedId) {
        var fetchedId = resolvedId || visitorID;
        fetchRecommendationsFor(fetchedId);
        _watchLateIdentity(fetchedId);
    });
} else {
    waitForResolvedVisitorId(2000).then(function (resolvedId) {
        if (resolvedId && lastCachedFor && resolvedId !== lastCachedFor) {
            fetchRecommendationsFor(resolvedId);
            _watchLateIdentity(resolvedId);
            return;
        }
        // Cache is valid -- run page updates with stored data.
        executePageUpdates(
            JSON.parse(cachedRecs),
            localStorage.getItem('tande'),
            localStorage.getItem('country')
        );
        // Still watch for a late identity update -- the engine might come
        // back with a DIFFERENT id than what we cached for (e.g. ip-match
        // on this device replaces what localStorage had). When it does,
        // refetch and re-apply with the canonical id.
        _watchLateIdentity(resolvedId || lastCachedFor || visitorID);
    });
}
localStorage.setItem('visitorID', visitorID);
if (!visitorID) {
    visitorID = generateUUID();
    sessionStorage.setItem('visitorIdGeneratedThisSession', 'true');
    setCookie('visitorID', visitorID, 300);
    localStorage.setItem('visitorID', visitorID);

}
if (visitorID) {
  const attributes = {
    visitorID: visitorID
  };

  // Try adding recommended products if available
  try {
    const recs = localStorage.getItem('recommendedProducts');
    if (recs && recs !== '[]') {
      const parsedRecs = JSON.parse(recs);
      parsedRecs.forEach((product, index) => {
        // No optional chaining here: recommendations.js loads raw (no
        // transpile step), and optional chaining on `product` is a parse error
        // on older browsers (iOS 12 Safari, Chrome 79) that kills the whole file.
        if (product && product.productName) {
          attributes[`Rec${index + 1}`] = product.productName;
        }
      });
    }
  } catch (err) {
    console.error("Error parsing recommendedProducts from localStorage:", err);
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: attributes
    })
  })
  .then(resp => resp.json())
  .then(cart => {
    console.log('Cart attributes updated:', cart.attributes);
  })
  .catch(err => {
    console.error('Could not set cart attributes:', err);
  });
}
    // Function to execute all page updates. Each sub-call is independently
    // wrapped so a thrown error in one (e.g. a malformed image URL kills
    // updateProductImages) doesn't prevent the others (reorder, nav update,
    // tande gate) from running. Validates recommendedProducts is an array
    // up-front; downstream code assumes that.
    function executePageUpdates(recommendedProducts, tande, country) {
        if (!Array.isArray(recommendedProducts)) recommendedProducts = [];
        try { updateMainNav(); } catch (e) { console.warn('updateMainNav failed', e); }
        // try { updateAnnouncementBar(country); } catch (e) {}
        try { hideSectionIfTandeIs1(tande); } catch (e) { console.warn('hideSectionIfTandeIs1 failed', e); }
        try { reorderProductList(recommendedProducts); } catch (e) { console.warn('reorderProductList failed', e); }
        try { reorderCollections(recommendedProducts); } catch (e) { console.warn('reorderCollections failed', e); }
        // try { updateSlideshow(recommendedProducts[0]); } catch (e) {}
        try { updateProductImages(recommendedProducts); } catch (e) { console.warn('updateProductImages failed', e); }
        // try { revealBadgesByPositions(recommendedProducts, [0,2,3]); } catch (e) {}
    }
    // Function to update the main navigation
    function updateMainNav() {
        console.log("Updating Navigation...");

        var navItems = document.querySelectorAll('.header__primary-nav-item');
        navItems.forEach(function(item) {
            var title = item.getAttribute('data-title');
            if (typeof title === 'string' && itemsToRemove.includes(title)) {
                item.remove();  // Remove the item if its title matches
            }
        });

        // Add collections to the navigation
        var collectionsToAdd = [
            { name: "Plate Carrier Accessories", url: "/collections/plate-carrier-accessories" },
            { name: "Combat Gear", url: "/collections/combat-gear" },
            { name: "Pouches", url: "/collections/pouches" }
        ];

        var navList = document.querySelector('.contents.unstyled-list');
        var firstNavItem = navList.querySelector('li.header__primary-nav-item');

        if (firstNavItem) {
            collectionsToAdd.forEach(function(collection) {
               var newNavItem = document.createElement('li');
                newNavItem.classList.add('header__primary-nav-item');
                newNavItem.innerHTML = `<a href="${collection.url}" class="block h5">${collection.name}</a>`;
                firstNavItem.insertAdjacentElement('afterend', newNavItem);
                firstNavItem = newNavItem;  // Update firstNavItem to ensure items are added sequentially
            });
        } else {
            console.error("First navigation item not found.");
        }
    }
    // Function to update the announcement bar
    function updateAnnouncementBar(country) {
        if (country && !['United States', 'USA', 'United States of America'].includes(country)) {
            var announcementBar = document.querySelector('.announcement-bar__carousel .prose');
            if (announcementBar) {
                announcementBar.textContent = `Great news! We ship directly to ${country}`;
            }
        }
    }
    // Function to hide section if tande equals 1
    function hideSectionIfTandeIs1(tande) {
        if (tande === "1") {
            var sectionToHide = document.querySelector('#shopify-section-template--17190971506940__e444e81a-0e07-46c5-b5f3-29850ec61577');
            if (sectionToHide) {
                sectionToHide.style.display = 'none';
            }
        }
    }
    // Function to reorder product list based on recommendations
    function reorderProductList(recommendedProducts) {
        if (!Array.isArray(recommendedProducts) || recommendedProducts.length === 0) return;
        var productListContainer = document.querySelector('#featured-collections-product-list-carousel-template--17094519816444__ec64810e-9fe1-4330-9c9d-6b05ac253e2e-collection-1');

        if (productListContainer) {
            let productCards = Array.from(productListContainer.querySelectorAll('product-card'));

            // Sorting product cards based on their position in recommendedProducts
            let sortedProductCards = productCards.sort((a, b) => {
                let handleA = a.getAttribute('handle');
                let handleB = b.getAttribute('handle');

                let indexA = recommendedProducts.findIndex(prod => prod.productLink === handleA);
                let indexB = recommendedProducts.findIndex(prod => prod.productLink === handleB);

                if (indexA === -1) indexA = Infinity; // Move non-recommended products to the end
                if (indexB === -1) indexB = Infinity;

                return indexA - indexB;
            });

            // Create a DocumentFragment to improve performance and avoid multiple reflows
            let fragment = document.createDocumentFragment();
            sortedProductCards.forEach(card => {
                fragment.appendChild(card);
            });

            // Clear the container and re-append the sorted cards
            productListContainer.innerHTML = ''; // Clear current content
            productListContainer.appendChild(fragment); // Append sorted products

            // Force the layout to repaint (browser hack to force the change)
            productListContainer.style.display = 'none';
            productListContainer.offsetHeight; // This forces a reflow/repaint
            productListContainer.style.display = '';

            // Optional: Re-initialize the carousel if applicable
            if (typeof refreshCarousel === 'function') {
                refreshCarousel();
            }

            console.log("Product list reordered successfully.");
        } else {
            console.error('Product list container not found.');
        }
}
    // Function to reorder collections based on recommended collections
    function reorderCollections(recommendedProducts) {
        if (!Array.isArray(recommendedProducts) || recommendedProducts.length === 0) return;
        // Get a list of recommended collections from the recommended products
        let recommendedCollections = [...new Set(recommendedProducts.map(product => product.collection))];

        // Select the collection list container
        let collectionList = document.querySelector('.collection-list');
        if (!collectionList) return;

        // Get all collection cards inside the collection list container
        let collectionCards = Array.from(collectionList.querySelectorAll('.collection-card'));

        // Sort collection cards based on whether they are recommended or not
        let sortedCollectionCards = collectionCards.sort((a, b) => {
            let hrefA = a.getAttribute('href');
            let hrefB = b.getAttribute('href');

            let isARecommended = recommendedCollections.includes(hrefA);
            let isBRecommended = recommendedCollections.includes(hrefB);

            // Recommended collections should come first
            if (isARecommended && !isBRecommended) {
                return -1;
            }
            if (!isARecommended && isBRecommended) {
                return 1;
            }
            return 0; // Keep original order if both are recommended or both are not
        });

        // Clear the collection list container and re-append the sorted collection cards
        collectionList.innerHTML = '';
        sortedCollectionCards.forEach(function (collection) {
            collectionList.appendChild(collection);
        });

        console.log('Collections reordered successfully.');
}
    // Function to update the first slideshow image
    function updateSlideshow(firstProduct) {
        // Extract relevant properties from the first recommended product
        let productHandle = firstProduct.productLink;
        let desktopImage = firstProduct.desktopBannerHTML;
        let mobileImage = firstProduct.mobileBannerHTML;
        let productUrl = `/products/${productHandle}`;

        // Update the slideshow with the images and URL of the first recommended product
        updateSlideshowImage(0, desktopImage, mobileImage, productUrl);
}
    // Function to update the slideshow image by index
    function updateSlideshowImage(slideIndex, desktopImage, mobileImage, productUrl) {
        // Select all slideshow slide elements
        let slides = document.querySelectorAll('.slideshow__slide');

        if (slides && slides[slideIndex]) {
            let slide = slides[slideIndex];

            // Update the link of the slide
            let slideLink = slide.querySelector('a');
            if (slideLink) {
                slideLink.setAttribute('href', productUrl);
            }

            // Update the mobile image source
            let mobileSource = slide.querySelector('source[media="(max-width: 699px)"]');
            if (mobileSource && mobileImage) {
                mobileSource.setAttribute('srcset', mobileImage);
            }

            // Update the desktop image
            let desktopImg = slide.querySelector('img');
            if (desktopImg && desktopImage) {
                desktopImg.setAttribute('src', desktopImage);
                desktopImg.setAttribute('srcset', desktopImage);
            }
        } else {
            console.warn('Slide not found for index:', slideIndex);
        }
}
    // Function to update product images based on the recommended color
    function updateProductImages(recommendedProducts) {
      if (!Array.isArray(recommendedProducts) || recommendedProducts.length === 0) return;
      console.log("First recommended product:", recommendedProducts[0]);
        // Get the fallback color from the first recommended product, if available
        const fallbackColor = recommendedProducts[0] && recommendedProducts[0].camo;
        if (!fallbackColor) return;
        
        // const fallbackColor = recommendedProducts[0].camo; This is the product color. 

        // Loop through all products on the page
        document.querySelectorAll('.product-card').forEach(async function(productCard) {
            let handle = productCard.getAttribute('handle');

            // Find the product in the recommendations based on productLink
            let recommendedProduct = recommendedProducts.find(product => product.productLink === handle);
            
            // Get the recommended color if available, otherwise use fallback color
            let recommendedColor = recommendedProduct ? recommendedProduct.camo : fallbackColor;

            console.log('Updating product:', handle, 'with recommended color:', recommendedColor);

            // Update the product card with the found color or fallback
            await updateProductCardWithRecommendedColor(handle, recommendedColor);
        });
}
    function revealBadgesByPositions(recommendedProducts, positions) {
        if (!Array.isArray(recommendedProducts)) return;

        positions.forEach(function(pos) {
            // only if within bounds
            if (pos >= 0 && pos < recommendedProducts.length) {
            var handle = recommendedProducts[pos].productLink;
            var badgeEl = document.querySelector(
                '.product-card[handle="' + handle + '"] .product-card__badge'
            );
            if (badgeEl) badgeEl.classList.remove('badge--hidden');
            }
        });
}
    // Fetch product from Shopify and update image
    async function fetchProductByHandle(handle) {
        const storefrontAccessToken = 'a1ce45ce18d6c11a2a5b3e7ec4154a28';
        const graphqlEndpoint = 'https://agilitegear.myshopify.com/api/2024-07/graphql.json';
        const query = `
        query ($handle: String!) {
          productByHandle(handle: $handle) {
            id
            title
            variants(first: 10) {
              edges {
                node {
                  id
                  title
                  image {
                    src
                    altText
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }`;
        const variables = { handle };
        try {
            const response = await fetch(graphqlEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                },
                body: JSON.stringify({ query, variables }),
            });
            if (!response.ok) {
                throw new Error('Failed to fetch product data');
            }
            const data = await response.json();
            return data.data.productByHandle;
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    }
    // Update product card image based on recommended color or fallback
    async function updateProductCardWithRecommendedColor(handle, recommendedColor, fallbackColor) {
        console.log(`Starting updateProductCardWithRecommendedColor for handle: ${handle}, recommendedColor: ${recommendedColor}, fallbackColor: ${fallbackColor}`);

        try {
            const product = await fetchProductByHandle(handle);
            if (product) {
                console.log(`Fetched product:`, product);

                const variants = product.variants.edges;
                console.log(`Product variants:`, variants);

                // Try to find a variant that includes the recommended color in any of its selected options
                const recommendedVariant = variants.find(variant => {
                    const matchesRecommendedColor = variant.node.selectedOptions.some(option =>
                        option.value.toLowerCase().includes(recommendedColor.toLowerCase())
                    );
                    console.log(`Checking variant for recommended color "${recommendedColor}":`, {
                        variant,
                        matchesRecommendedColor
                    });
                    return matchesRecommendedColor;
                }) || variants.find(variant => {
                    // If no recommended color variant found, fall back to a variant that includes the fallback color
                    const matchesFallbackColor = variant.node.selectedOptions.some(option =>
                        option.value.toLowerCase().includes(fallbackColor.toLowerCase())
                    );
                    console.log(`Checking variant for fallback color "${fallbackColor}":`, {
                        variant,
                        matchesFallbackColor
                    });
                    return matchesFallbackColor;
                });

                if (recommendedVariant) {
                    console.log(`Recommended or fallback variant found:`, recommendedVariant);

                    if (recommendedVariant.node.image) {
                        const productCard = document.querySelector(`.product-card[handle="${handle}"]`);
                        if (productCard) {
                            console.log(`Product card found for handle "${handle}":`, productCard);

                            const imgElement = productCard.querySelector('.product-card__image--primary');
                            if (imgElement) {
                                console.log(`Updating image element for handle "${handle}" with recommended color "${recommendedColor}"`);

                                imgElement.setAttribute('src', recommendedVariant.node.image.src);
                                imgElement.setAttribute('srcset', `${recommendedVariant.node.image.src} 1000w`);
                                imgElement.setAttribute('alt', `${product.title} - ${recommendedColor}`);
                            } else {
                                console.warn(`Image element not found in product card for handle "${handle}"`);
                            }
                        } else {
                            console.error(`Product card with handle "${handle}" not found`);
                        }
                    } else {
                        console.warn(`No image found for the recommended variant of handle "${handle}"`);
                    }
                } else {
                    console.warn(`No suitable variant found for handle "${handle}" with recommended color "${recommendedColor}" or fallback color "${fallbackColor}"`);
                }
            } else {
                console.error(`No product found for handle "${handle}"`);
            }
        } catch (error) {
            console.error(`Error in updateProductCardWithRecommendedColor for handle "${handle}":`, error);
        }
}

});
